export default __webpack_public_path__ + "static/media/03_sazenice.a6f120d8.jpg";